import uniqid from 'uniqid'
import GitHubIcon from '@material-ui/icons/GitHub'
import LaunchIcon from '@material-ui/icons/Launch'
import './ProjectsContainer.css'
// import ArboretumIDPDF from '../../pdf/ArboretumID.pdf';

const ProjectContainer = ({ project }) => (
  <div className='projects'>
    <h3>{project.name}</h3>

    <p className='projects__description'>{project.description}</p>
    {project.stack && (
      <ul className='projects__stack'>
        {project.stack.map((item) => (
          <li key={uniqid()} className='projects__stack-item'>
            {item}
          </li>
        ))}
      </ul>
    )}

    {project.sourceCode && (
      <a href={project.sourceCode} aria-label='source code' className='link link--icon'>
        <GitHubIcon />
      </a>
    )}

    {project.livePreview && (
      <a href={project.livePreview} aria-label='live preview' className='link link--icon'>
        <LaunchIcon />
      </a>
    )}
    
  </div>
)

export default ProjectContainer
